export const environment = {
  production: true,
  apiUrl: "https://umyosports.site/api_umyocards/public/api/"
};


